module.exports = __webpack_public_path__ + "static/media/eng_d_2503.0cc2ff80.vtt";